import { CheckCircle2 } from 'lucide-react';
import type { MoneyAmount, TripDispatchRecord } from '../dispatch.api';

const kes = (money: MoneyAmount | null) => (money ? `KES ${(money.amountMinor / 100).toLocaleString('en-KE')}` : 'None');

/** What was committed when the trip went, shown in place of the form once it has. */
export function DispatchedSummary({ record }: { record: TripDispatchRecord }) {
  const rows: [string, string][] = [
    ['Fuel', record.fuelAllocationLitres ? `${record.fuelAllocationLitres} litres` : 'None'],
    ['Driver advance', kes(record.advance)],
    ['Expected tolls', kes(record.expectedTolls)],
    ['Expected weighbridge', kes(record.expectedWeighbridge)],
  ];
  return (
    <section aria-label="Dispatched" className="rounded-lg border border-line bg-surface p-5">
      <h2 className="mb-3 flex items-center gap-2 text-base font-semibold text-fg">
        <CheckCircle2 className="size-5 text-success" aria-hidden /> Dispatched
      </h2>
      <dl className="grid grid-cols-[10rem_1fr] gap-y-2 text-sm">
        {rows.map(([term, value]) => (
          <div key={term} className="contents">
            <dt className="text-muted">{term}</dt>
            <dd className="text-fg">{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
